export default {
  REDIRECT: 'redirect',
  IN_APP: 'in-app',
};
